import React from 'react';
import { motion } from 'framer-motion';
import { WrenchIcon, FlameIcon, BrainIcon } from 'lucide-react';
const layers = [{
  icon: WrenchIcon,
  title: 'Structural Repair',
  description: 'Close the diastasis, restore the pelvic floor, rebuild the base'
}, {
  icon: FlameIcon,
  title: 'Hormonal Nutrition',
  description: 'Feed the new chemistry, not fight it'
}, {
  icon: BrainIcon,
  title: 'Identity Recalibration',
  description: 'Rewire the brain to remember she still exists'
}];
export function MechanismSection() {
  return <section className="bg-[#81B29A]/10 px-4 py-14 sm:px-6 lg:px-8 lg:py-20" data-id="element-104">
      <div className="mx-auto max-w-4xl" data-id="element-105">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="mb-10 text-center" data-id="element-106">
          <h2 className="mb-6 font-serif text-4xl font-bold text-[#2D2D2D] sm:text-5xl" data-id="element-107">
            Here's what actually changed — and why it changes everything:
          </h2>
          <p className="font-serif text-3xl italic text-[#81B29A]" data-id="element-108">
            Think of your body as a smartphone.
          </p>
        </motion.div>

        <div className="mx-auto mb-10 max-w-3xl space-y-6 font-sans text-xl leading-loose text-[#2D2D2D]/90" data-id="element-109">
          <p data-id="element-110">
            Before pregnancy, you were running a specific operating system. Apps
            worked. Processes ran smoothly. The system was calibrated.
          </p>
          <p data-id="element-111">
            Pregnancy didn't just update one app.{' '}
            <strong className="font-bold text-[#2D2D2D]" data-id="element-112">
              It replaced the entire operating system.
            </strong>
          </p>
          <p data-id="element-113">
            Your hormones shifted. Your core architecture changed. Your brain
            literally rewired itself to be hypervigilant, hyper-responsive, and
            hyper-focused on another human being's survival. Your sleep
            architecture changed. Your metabolism changed. Your identity
            changed.
          </p>
          <p data-id="element-114">
            And here you are, trying to run the old apps — the extreme diets,
            the brutal cardio, the willpower-based systems — on completely new
            hardware.
          </p>
          <div className="my-6 border-l-4 border-[#81B29A] bg-white/60 p-6 rounded-r-lg" data-id="element-115">
            <p className="font-serif text-2xl font-bold text-[#2D2D2D]" data-id="element-116">
              The system keeps crashing. Not because you're broken. Because the
              software is incompatible.
            </p>
          </div>
          <p className="text-center font-serif text-2xl italic text-[#D4603A]" data-id="element-117">
            What you need isn't more discipline.
            <br data-id="element-118" />
            What you need is a complete system update.
          </p>
        </div>

        <div className="mt-12" data-id="element-119">
          <h3 className="mb-8 text-center font-serif text-3xl font-bold text-[#2D2D2D]" data-id="element-120">
            The Back To You Mechanism: Version 2.0
          </h3>
          <div className="grid gap-8 sm:grid-cols-3" data-id="element-121">
            {layers.map((layer, index) => {
            const Icon = layer.icon;
            return <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.2
            }} className="flex flex-col items-center rounded-2xl bg-white p-8 text-center shadow-lg" data-id="element-122">
                  <div className="mb-6 rounded-full bg-[#81B29A]/20 p-4" data-id="element-123">
                    <Icon className="h-8 w-8 text-[#81B29A]" data-id="element-124" />
                  </div>
                  <h4 className="mb-4 font-serif text-xl font-bold text-[#2D2D2D]" data-id="element-125">
                    {layer.title}
                  </h4>
                  <p className="font-sans text-[#2D2D2D]/80" data-id="element-126">
                    {layer.description}
                  </p>
                </motion.div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}